import React, { useEffect, useState } from 'react';
import P5Wrapper from 'react-p5-wrapper';
import sketch from '../sketches/homeSketch';

const DESKTOP_MQ = '(min-width: 1025px)';

/** Bird game — desktop only; never mount on phones or tablets. */
export default function GameBoard(props) {
  const [show, setShow] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(DESKTOP_MQ).matches
  );

  useEffect(() => {
    const media = window.matchMedia(DESKTOP_MQ);
    const onChange = () => setShow(media.matches);
    onChange();
    if (media.addEventListener) {
      media.addEventListener('change', onChange);
      return () => media.removeEventListener('change', onChange);
    }
    media.addListener(onChange);
    return () => media.removeListener(onChange);
  }, []);

  if (!show) return null;

  return (
    <div
      className={
        'game-board' + (props.contained ? ' game-board--contained' : '')
      }
    >
      <P5Wrapper sketch={sketch} {...props} />
    </div>
  );
}
